export class Company {
    companyId: number;
    companyName: string;
    email: string;
    phone: string;
    companyAddress: string;
    city: string;
    state: string;
    country: string;
    contactPersonName: string;
    contactPhone: string;
    contactEmail: string;
    activatedTill: string;
    isActivated: boolean;
    companyType: number;
    logopath: string;   
    
   
}
